module.exports = __webpack_public_path__ + "img/skills_graphic_EN_US.757175f9.png";